import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { AntiSpamSwitchType } from '../constants';

// eslint-disable-next-line react-func/max-lines-per-function
export const getNormalServices = ({ GateWayInstance }: { GateWayInstance: AxiosInstance }) => ({
  getShortUrl(longRrl: string) {
    return GateWayInstance.post<{ url: string }>('/short', { url: longRrl });
  },
  postPhoto({ data }: { data: FormData }) {
    return GateWayInstance.post<{ url: string }>(`/images`, data);
  },
  getImageUrl({
    file,
    need_compress,
    need_origin,
    image_type,
    antiSpamSwitchType,
    activityId,
  }: {
    file: Blob;
    need_compress?: '1';
    need_origin?: '1';
    image_type?: 'common' | 'avatar';
    antiSpamSwitchType?: AntiSpamSwitchType;
    activityId?: string;
  }) {
    const formData = new FormData();
    formData.append('file', file);
    need_compress && formData.append('need_compress', need_compress);
    need_origin && formData.append('need_origin', need_origin);
    image_type && formData.append('image_type', image_type);
    activityId && formData.append('activity_id', activityId);
    antiSpamSwitchType && formData.append('switch_type', antiSpamSwitchType);
    return GateWayInstance.post<{ url: string; original_url?: string }>(`/images`, formData);
  },
  upload(option: string | AxiosRequestConfig, params: { [key: string]: any }) {
    const formData = new FormData();
    typeof params === 'object' &&
      Object.keys(params).forEach(item => {
        if (params?.[item] instanceof Blob) {
          formData.append(item, params?.[item], params?.[item]?.name);
        } else {
          formData.append(item, params?.[item]);
        }
      });
    const options = {
      method: 'post',
      data: formData,
      ...(typeof option === 'object' ? option : { url: option }),
    };
    return GateWayInstance({ ...options } as AxiosRequestConfig);
  },
});
